import { BASE_API_PATH } from "@/utils/variable";
import server from '@/utils/request'
import { SearchHistoryList } from 'components/Search/types'

export const FILE_UPLOAD = `${BASE_API_PATH}/static/file/upload`;

/**
 * Save search history
 * @param data
 * @param target
 */
export const saveSearchHistory = (data: any, target:string) => server.post(`/user/settings/${target}`, data)

/**
 * Get search history
 * @param target
 */
export const getSearchHistory = (target:string) => server.get<SearchHistoryList[]>(`/user/settings/${target}`)

/**
 * Delete specified search history
 * @param id
 * @param target
 */
export const deleteSearchHistory = (target:string, id:string) => server.remove<SearchHistoryList[]>(`/user/settings/${target}/${id}`)

/**
 * Get current system version
 */
export const systemVersion = () => server.get<{edition?: string}>('/system/version')

/**
 * Aggregate query
 * @param data 
 * @returns 
 */
export const queryDashboard = (data: Record<string, any>) => server.post(`/dashboard/_multi`, data)
